import React from "react";
import { CardDeckWrapper } from "./styles/CardDeck.styled";
import { CTAWrap, CardGrid, CardWrap, ContentWrap, CtaCard, Heading, LogoLink, LogoWrap, Subheading, TextContent } from "./styles/CardDeckCta.styled";
import { switchbackResolveRichText } from "../../utils/resolve-rich-text/switchbackResolveRichText"
import { Button } from "../../atoms/Button";
import { StaticImage } from "gatsby-plugin-image";
import { Spotify, Amazon, ApplePodcast } from "../../utils/IconsList";

const BackgroundImage = ({ cardNo }) => {
  switch (cardNo) {
    case "card-0":
      return (
        <StaticImage src="../../../static/images/home-hero-back.webp" className="background-image" />
      )
    case "card-1":
      return (
        <StaticImage src="../../../static/images/nav-mobile-footer.webp" className="background-image" />
      )
    default:
      return (
        <StaticImage src="../../../static/images/home-hero-back.webp" className="background-image" />
      )
  }
}

const Buttons = ({ podcastListing, ctas, cardNo }) => {
  if (podcastListing) {
    return (
      <CTAWrap>
        {cardNo === "card-0"
          ? (ctas ? ctas?.map(cta => (
            <Button
              ctaLink={cta?.link}
              ctaVariant={"tertiary"}
              {...cta}
            >
              {cta?.label}
            </Button>
          )) : <Button ctaLink="/about/contact/" ctaVariant="tertiary">Inquire</Button>)
          : <LogoWrap>
            <LogoLink href="https://open.spotify.com/show/7AVV8GvtDdpOzeS2mL4Iw6?si=133115f21d844298" target="_blank" rel="noreferrer">
              <Spotify />
            </LogoLink>
            <LogoLink href="https://music.amazon.com/podcasts/c3758a01-d1ea-4474-837e-4c59e0c0ffb4/the-workgrid" target="_blank" rel="noreferrer">
              <Amazon />
            </LogoLink>
            <LogoLink href="https://podcasts.apple.com/us/podcast/the-workgrid/id1694988359" target="_blank" rel="noreferrer">
              <ApplePodcast />
            </LogoLink>
          </LogoWrap>
        }
      </CTAWrap>
    )
  } else {
    return (
      <>
        {ctas &&
          <CTAWrap>
            {ctas.map(cta => (
              <Button
                ctaLink={cta?.link}
                ctaVariant={"tertiary"}
                {...cta}
              >
                {cta?.label}
              </Button>
            ))}
          </CTAWrap>
        }
      </>
    )
  }
}

const CardDeckCta = ({ backgroundColor, podcastListing, cards, noTopPadding, noBottomPadding }) => (
  <CardDeckWrapper backgroundColor={backgroundColor && backgroundColor} noTopPadding={noTopPadding} noBottomPadding={noBottomPadding}>
    <ContentWrap>
      <CardGrid>
        {cards && cards.map((card, index) => {
          let cardNo = `card-${index}`
          return (
            <CardWrap>
              <BackgroundImage cardNo={cardNo} />
              <CtaCard key={card?.heading} number={cardNo}>
                <TextContent>
                  {card?.heading && <Heading>{card?.heading}</Heading>}
                  {card?.bodyCopy?.raw && <Subheading>{switchbackResolveRichText(card?.bodyCopy)}</Subheading>}
                </TextContent>
                <Buttons podcastListing={podcastListing} ctas={card?.callsToAction} cardNo={cardNo} />
              </CtaCard>
            </CardWrap>
          )
        })}
      </CardGrid>
    </ContentWrap>
  </CardDeckWrapper>
)

export default CardDeckCta